const URL_PATTERN = /https?:\/\/[^\s<>"']+/g;

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** escapes plain text for v-html and turns its http(s) URLs into links that open in a new tab */
export function linkifyText(text: string): string {
  return escapeHtml(text)
    .replace(URL_PATTERN, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`)
    .replace(/\n/g, '<br>');
}
